export default __webpack_public_path__ + "static/media/1_0114.00e8256a.webp";